// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/aoknos_logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Modern Design System - AI CardioMeter
   ============================================ */

:root {
  /* Color Palette */
  --primary-color: #2563eb;
  --primary-dark: #1e40af;
  --primary-light: #3b82f6;
  --secondary-color: #10b981;
  --accent-color: #f59e0b;
  --danger-color: #ef4444;

  /* Neutral Colors */
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --border-color: #e2e8f0;
  --border-light: #f1f5f9;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;

  /* Border Radius */
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;

  /* Typography */
  --font-sans: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  --font-mono: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, monospace;
}

/* ============================================
   Global Resets & Base Styles
   ============================================ */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-sans);
  color: var(--text-primary);
  background-color: var(--bg-secondary);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ============================================
   App Container
   ============================================ */

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
}

/* ============================================
   Header / Navigation Bar
   ============================================ */

.App-logo {
  background: var(--bg-primary);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-md) var(--spacing-xl);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--border-color);
}

.logo-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  height: 60px;
}

.logo-container::before {
  content: "";
  width: 180px;
  height: 60px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
}

.logo-container h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  padding: 0;
}

/* ============================================
   Main Content Area
   ============================================ */

.main-content {
  flex: 1 1;
  padding: var(--spacing-xl);
  width: 100%;
}

/* ============================================
   Tabs Navigation
   ============================================ */

.tabs-container {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  min-height: 600px;
}

.tabs-header {
  background: linear-gradient(to right, var(--bg-tertiary), var(--bg-secondary));
  border-bottom: 2px solid var(--border-color);
  display: flex;
  padding: var(--spacing-sm);
  gap: var(--spacing-sm);
  overflow-x: auto;
  scrollbar-width: thin;
}

.tabs-header::-webkit-scrollbar {
  height: 4px;
}

.tabs-header::-webkit-scrollbar-track {
  background: transparent;
}

.tabs-header::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 2px;
}

.tabs-header button {
  flex: 1 1;
  min-width: 180px;
  padding: var(--spacing-md) var(--spacing-lg);
  background: transparent;
  border: 2px solid transparent;
  border-radius: var(--radius-md);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  position: relative;
}

.tabs-header button:hover {
  background: rgba(37, 99, 235, 0.05);
  color: var(--primary-color);
}

.tabs-header button.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-dark);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.tabs-header button.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 3px;
  background: white;
  border-radius: 2px 2px 0 0;
}

.tab-icon {
  font-size: 1.2rem;
  margin-right: var(--spacing-sm);
  display: inline-block;
  transition: transform 0.2s ease;
}

.tabs-header button:hover .tab-icon {
  transform: scale(1.1);
}

.tabs-header button.active .tab-icon {
  animation: iconBounce 0.5s ease;
}

@keyframes iconBounce {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}

.tab-label {
  display: inline-block;
}

/* ============================================
   Tabs Content
   ============================================ */

.tabs-content {
  padding: var(--spacing-xl);
  background: var(--bg-primary);
  min-height: 500px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================
   Forms & Inputs
   ============================================ */

input[type='text'],
input[type='email'],
input[type='number'],
input[type='file'],
select,
textarea {
  width: 100%;
  padding: var(--spacing-md);
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 0.95rem;
  font-family: var(--font-sans);
  color: var(--text-primary);
  background: var(--bg-primary);
  transition: all 0.2s ease;
  outline: none;
}

input:focus,
select:focus,
textarea:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

input:disabled,
select:disabled,
textarea:disabled {
  background: var(--bg-tertiary);
  color: var(--text-muted);
  cursor: not-allowed;
}

label {
  display: block;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--spacing-sm);
  font-size: 0.9rem;
}

.filter-input {
  max-width: 400px;
  margin-bottom: var(--spacing-lg);
}

.filter-column-input {
  width: 100%;
  padding: var(--spacing-sm);
  font-size: 0.85rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
}

/* ============================================
   Buttons
   ============================================ */

button {
  padding: var(--spacing-md) var(--spacing-xl);
  font-size: 0.95rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--font-sans);
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  background: var(--primary-color);
  color: white;
  box-shadow: var(--shadow-sm);
}

button:hover {
  background: var(--primary-dark);
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}

button:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

button:disabled {
  background: var(--bg-tertiary);
  color: var(--text-muted);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

button.secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 2px solid var(--border-color);
}

button.secondary:hover {
  background: var(--bg-secondary);
  border-color: var(--primary-color);
}

button.danger {
  background: var(--danger-color);
}

button.danger:hover {
  background: #dc2626;
}

button.success {
  background: var(--secondary-color);
}

button.success:hover {
  background: #059669;
}

/* ============================================
   Tables
   ============================================ */

.table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  margin-bottom: var(--spacing-md);
}

.table-container::-webkit-scrollbar {
  height: 12px;
}

.table-container::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}

.table-container::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 6px;
  border: 2px solid var(--bg-secondary);
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: var(--primary-dark);
}

.table {
  width: 100%;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.9rem;
  background: var(--bg-primary);
  margin: 0;
}

.table thead {
  background: linear-gradient(to right, var(--bg-tertiary), var(--bg-secondary));
}

.table th {
  padding: var(--spacing-md);
  text-align: left;
  font-weight: 700;
  color: var(--text-primary);
  border: 1px solid #64748b;
  border-bottom: 2px solid #475569;
  position: sticky;
  top: 0;
  background: var(--bg-tertiary);
  z-index: 10;
}

.table td {
  padding: var(--spacing-md);
  border: 1px solid #cbd5e1;
  color: var(--text-primary);
}

.table tbody tr {
  transition: background-color 0.15s ease;
}

.table tbody tr:hover {
  background: var(--bg-secondary);
}

.table tbody tr:nth-child(even) {
  background: var(--bg-primary);
}

.table tbody tr:nth-child(odd) {
  background: rgba(248, 250, 252, 0.5);
}

/* ============================================
   Modals / Popups
   ============================================ */

.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: overlayFadeIn 0.2s ease;
}

@keyframes overlayFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.popup-content {
  background: var(--bg-primary);
  padding: var(--spacing-xl);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: popupSlideIn 0.3s ease;
}

@keyframes popupSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.popup-content h3 {
  margin-top: 0;
  margin-bottom: var(--spacing-lg);
  font-size: 1.5rem;
  color: var(--text-primary);
}

.popup-content textarea {
  width: 100%;
  min-height: 120px;
  resize: vertical;
}

/* ============================================
   Loading Spinner
   ============================================ */

.spinner {
  border: 4px solid var(--border-light);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
  margin: var(--spacing-xl) auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2xl);
  gap: var(--spacing-lg);
}

.loading-text {
  color: var(--text-secondary);
  font-size: 0.95rem;
}

/* ============================================
   Utility Classes
   ============================================ */

.text-center {
  text-align: center;
}

.mt-1 { margin-top: var(--spacing-sm); }
.mt-2 { margin-top: var(--spacing-md); }
.mt-3 { margin-top: var(--spacing-lg); }
.mt-4 { margin-top: var(--spacing-xl); }

.mb-1 { margin-bottom: var(--spacing-sm); }
.mb-2 { margin-bottom: var(--spacing-md); }
.mb-3 { margin-bottom: var(--spacing-lg); }
.mb-4 { margin-bottom: var(--spacing-xl); }

.p-1 { padding: var(--spacing-sm); }
.p-2 { padding: var(--spacing-md); }
.p-3 { padding: var(--spacing-lg); }
.p-4 { padding: var(--spacing-xl); }

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-1 { gap: var(--spacing-sm); }
.gap-2 { gap: var(--spacing-md); }
.gap-3 { gap: var(--spacing-lg); }

/* ============================================
   Responsive Design
   ============================================ */

@media (max-width: 768px) {
  .App-logo {
    padding: var(--spacing-md);
  }

  .logo-container::before {
    width: 120px;
    height: 40px;
  }

  .main-content {
    padding: var(--spacing-md);
  }

  .tabs-header {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .tabs-header button {
    min-width: 140px;
    font-size: 0.85rem;
    padding: var(--spacing-sm) var(--spacing-md);
  }

  .tabs-content {
    padding: var(--spacing-md);
  }

  .popup-content {
    width: 95%;
    padding: var(--spacing-lg);
  }

  .table {
    font-size: 0.8rem;
  }

  .table th,
  .table td {
    padding: var(--spacing-sm);
  }
}

@media (max-width: 480px) {
  .tabs-header button {
    min-width: 120px;
    font-size: 0.8rem;
  }
}

/* ============================================
   Card Components
   ============================================ */

.card {
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  padding: var(--spacing-xl);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
}

.card-header {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid var(--border-light);
}

.card-body {
  color: var(--text-secondary);
}

/* ============================================
   Badges & Status Indicators
   ============================================ */

.badge {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-xs) var(--spacing-md);
  border-radius: var(--radius-md);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-success {
  background: rgba(16, 185, 129, 0.1);
  color: var(--secondary-color);
}

.badge-warning {
  background: rgba(245, 158, 11, 0.1);
  color: var(--accent-color);
}

.badge-danger {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.badge-info {
  background: rgba(37, 99, 235, 0.1);
  color: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;;EAEvB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;;EAEvB,YAAY;EACZ,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;;EAEtF,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;;EAEjB,eAAe;EACf,iHAAiH;EACjH,mFAAmF;AACrF;;AAEA;;iDAEiD;;AAEjD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yDAAkD;EAClD,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,UAAU;AACZ;;AAEA;;iDAEiD;;AAEjD;EACE,SAAO;EACP,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8EAA8E;EAC9E,4CAA4C;EAC5C,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,4CAA4C;EAC5C,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,iCAAiC;EACjC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;iDAEiD;;AAEjD;;;;;;EAME,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;;;EAGE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;AACpB;;AAEA,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;;AAEvC,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;;AAE1C,OAAO,0BAA0B,EAAE;AACnC,OAAO,0BAA0B,EAAE;AACnC,OAAO,0BAA0B,EAAE;AACnC,OAAO,0BAA0B,EAAE;;AAEnC;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,SAAS,sBAAsB,EAAE;AACjC,SAAS,sBAAsB,EAAE;AACjC,SAAS,sBAAsB,EAAE;;AAEjC;;iDAEiD;;AAEjD;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;EAC5C,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B","sourcesContent":["/* ============================================\n   Modern Design System - AI CardioMeter\n   ============================================ */\n\n:root {\n  /* Color Palette */\n  --primary-color: #2563eb;\n  --primary-dark: #1e40af;\n  --primary-light: #3b82f6;\n  --secondary-color: #10b981;\n  --accent-color: #f59e0b;\n  --danger-color: #ef4444;\n\n  /* Neutral Colors */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8fafc;\n  --bg-tertiary: #f1f5f9;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --text-muted: #94a3b8;\n  --border-color: #e2e8f0;\n  --border-light: #f1f5f9;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-2xl: 3rem;\n\n  /* Border Radius */\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n\n  /* Typography */\n  --font-sans: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  --font-mono: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, monospace;\n}\n\n/* ============================================\n   Global Resets & Base Styles\n   ============================================ */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-sans);\n  color: var(--text-primary);\n  background-color: var(--bg-secondary);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ============================================\n   App Container\n   ============================================ */\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-secondary);\n}\n\n/* ============================================\n   Header / Navigation Bar\n   ============================================ */\n\n.App-logo {\n  background: var(--bg-primary);\n  box-shadow: var(--shadow-md);\n  padding: var(--spacing-md) var(--spacing-xl);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  height: 60px;\n}\n\n.logo-container::before {\n  content: \"\";\n  width: 180px;\n  height: 60px;\n  background-image: url('../images/aoknos_logo.png');\n  background-repeat: no-repeat;\n  background-position: left center;\n  background-size: contain;\n}\n\n.logo-container h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  padding: 0;\n}\n\n/* ============================================\n   Main Content Area\n   ============================================ */\n\n.main-content {\n  flex: 1;\n  padding: var(--spacing-xl);\n  width: 100%;\n}\n\n/* ============================================\n   Tabs Navigation\n   ============================================ */\n\n.tabs-container {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n  min-height: 600px;\n}\n\n.tabs-header {\n  background: linear-gradient(to right, var(--bg-tertiary), var(--bg-secondary));\n  border-bottom: 2px solid var(--border-color);\n  display: flex;\n  padding: var(--spacing-sm);\n  gap: var(--spacing-sm);\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n\n.tabs-header::-webkit-scrollbar {\n  height: 4px;\n}\n\n.tabs-header::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.tabs-header::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 2px;\n}\n\n.tabs-header button {\n  flex: 1;\n  min-width: 180px;\n  padding: var(--spacing-md) var(--spacing-lg);\n  background: transparent;\n  border: 2px solid transparent;\n  border-radius: var(--radius-md);\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  position: relative;\n}\n\n.tabs-header button:hover {\n  background: rgba(37, 99, 235, 0.05);\n  color: var(--primary-color);\n}\n\n.tabs-header button.active {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-dark);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.tabs-header button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60%;\n  height: 3px;\n  background: white;\n  border-radius: 2px 2px 0 0;\n}\n\n.tab-icon {\n  font-size: 1.2rem;\n  margin-right: var(--spacing-sm);\n  display: inline-block;\n  transition: transform 0.2s ease;\n}\n\n.tabs-header button:hover .tab-icon {\n  transform: scale(1.1);\n}\n\n.tabs-header button.active .tab-icon {\n  animation: iconBounce 0.5s ease;\n}\n\n@keyframes iconBounce {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.15);\n  }\n}\n\n.tab-label {\n  display: inline-block;\n}\n\n/* ============================================\n   Tabs Content\n   ============================================ */\n\n.tabs-content {\n  padding: var(--spacing-xl);\n  background: var(--bg-primary);\n  min-height: 500px;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ============================================\n   Forms & Inputs\n   ============================================ */\n\ninput[type='text'],\ninput[type='email'],\ninput[type='number'],\ninput[type='file'],\nselect,\ntextarea {\n  width: 100%;\n  padding: var(--spacing-md);\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 0.95rem;\n  font-family: var(--font-sans);\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  transition: all 0.2s ease;\n  outline: none;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\ninput:disabled,\nselect:disabled,\ntextarea:disabled {\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n  cursor: not-allowed;\n}\n\nlabel {\n  display: block;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-sm);\n  font-size: 0.9rem;\n}\n\n.filter-input {\n  max-width: 400px;\n  margin-bottom: var(--spacing-lg);\n}\n\n.filter-column-input {\n  width: 100%;\n  padding: var(--spacing-sm);\n  font-size: 0.85rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n}\n\n/* ============================================\n   Buttons\n   ============================================ */\n\nbutton {\n  padding: var(--spacing-md) var(--spacing-xl);\n  font-size: 0.95rem;\n  font-weight: 600;\n  border: none;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: var(--font-sans);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  background: var(--primary-color);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\nbutton:hover {\n  background: var(--primary-dark);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-1px);\n}\n\nbutton:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n}\n\nbutton:disabled {\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\nbutton.secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 2px solid var(--border-color);\n}\n\nbutton.secondary:hover {\n  background: var(--bg-secondary);\n  border-color: var(--primary-color);\n}\n\nbutton.danger {\n  background: var(--danger-color);\n}\n\nbutton.danger:hover {\n  background: #dc2626;\n}\n\nbutton.success {\n  background: var(--secondary-color);\n}\n\nbutton.success:hover {\n  background: #059669;\n}\n\n/* ============================================\n   Tables\n   ============================================ */\n\n.table-container {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: visible;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n  margin-bottom: var(--spacing-md);\n}\n\n.table-container::-webkit-scrollbar {\n  height: 12px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: var(--primary-color);\n  border-radius: 6px;\n  border: 2px solid var(--bg-secondary);\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-dark);\n}\n\n.table {\n  width: 100%;\n  min-width: 1200px;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.9rem;\n  background: var(--bg-primary);\n  margin: 0;\n}\n\n.table thead {\n  background: linear-gradient(to right, var(--bg-tertiary), var(--bg-secondary));\n}\n\n.table th {\n  padding: var(--spacing-md);\n  text-align: left;\n  font-weight: 700;\n  color: var(--text-primary);\n  border: 1px solid #64748b;\n  border-bottom: 2px solid #475569;\n  position: sticky;\n  top: 0;\n  background: var(--bg-tertiary);\n  z-index: 10;\n}\n\n.table td {\n  padding: var(--spacing-md);\n  border: 1px solid #cbd5e1;\n  color: var(--text-primary);\n}\n\n.table tbody tr {\n  transition: background-color 0.15s ease;\n}\n\n.table tbody tr:hover {\n  background: var(--bg-secondary);\n}\n\n.table tbody tr:nth-child(even) {\n  background: var(--bg-primary);\n}\n\n.table tbody tr:nth-child(odd) {\n  background: rgba(248, 250, 252, 0.5);\n}\n\n/* ============================================\n   Modals / Popups\n   ============================================ */\n\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.7);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: overlayFadeIn 0.2s ease;\n}\n\n@keyframes overlayFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.popup-content {\n  background: var(--bg-primary);\n  padding: var(--spacing-xl);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: popupSlideIn 0.3s ease;\n}\n\n@keyframes popupSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.popup-content h3 {\n  margin-top: 0;\n  margin-bottom: var(--spacing-lg);\n  font-size: 1.5rem;\n  color: var(--text-primary);\n}\n\n.popup-content textarea {\n  width: 100%;\n  min-height: 120px;\n  resize: vertical;\n}\n\n/* ============================================\n   Loading Spinner\n   ============================================ */\n\n.spinner {\n  border: 4px solid var(--border-light);\n  border-top: 4px solid var(--primary-color);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 0.8s linear infinite;\n  margin: var(--spacing-xl) auto;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2xl);\n  gap: var(--spacing-lg);\n}\n\n.loading-text {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n/* ============================================\n   Utility Classes\n   ============================================ */\n\n.text-center {\n  text-align: center;\n}\n\n.mt-1 { margin-top: var(--spacing-sm); }\n.mt-2 { margin-top: var(--spacing-md); }\n.mt-3 { margin-top: var(--spacing-lg); }\n.mt-4 { margin-top: var(--spacing-xl); }\n\n.mb-1 { margin-bottom: var(--spacing-sm); }\n.mb-2 { margin-bottom: var(--spacing-md); }\n.mb-3 { margin-bottom: var(--spacing-lg); }\n.mb-4 { margin-bottom: var(--spacing-xl); }\n\n.p-1 { padding: var(--spacing-sm); }\n.p-2 { padding: var(--spacing-md); }\n.p-3 { padding: var(--spacing-lg); }\n.p-4 { padding: var(--spacing-xl); }\n\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.gap-1 { gap: var(--spacing-sm); }\n.gap-2 { gap: var(--spacing-md); }\n.gap-3 { gap: var(--spacing-lg); }\n\n/* ============================================\n   Responsive Design\n   ============================================ */\n\n@media (max-width: 768px) {\n  .App-logo {\n    padding: var(--spacing-md);\n  }\n\n  .logo-container::before {\n    width: 120px;\n    height: 40px;\n  }\n\n  .main-content {\n    padding: var(--spacing-md);\n  }\n\n  .tabs-header {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n  }\n\n  .tabs-header button {\n    min-width: 140px;\n    font-size: 0.85rem;\n    padding: var(--spacing-sm) var(--spacing-md);\n  }\n\n  .tabs-content {\n    padding: var(--spacing-md);\n  }\n\n  .popup-content {\n    width: 95%;\n    padding: var(--spacing-lg);\n  }\n\n  .table {\n    font-size: 0.8rem;\n  }\n\n  .table th,\n  .table td {\n    padding: var(--spacing-sm);\n  }\n}\n\n@media (max-width: 480px) {\n  .tabs-header button {\n    min-width: 120px;\n    font-size: 0.8rem;\n  }\n}\n\n/* ============================================\n   Card Components\n   ============================================ */\n\n.card {\n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-xl);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n}\n\n.card-header {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-md);\n  border-bottom: 2px solid var(--border-light);\n}\n\n.card-body {\n  color: var(--text-secondary);\n}\n\n/* ============================================\n   Badges & Status Indicators\n   ============================================ */\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--spacing-xs) var(--spacing-md);\n  border-radius: var(--radius-md);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.badge-success {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--secondary-color);\n}\n\n.badge-warning {\n  background: rgba(245, 158, 11, 0.1);\n  color: var(--accent-color);\n}\n\n.badge-danger {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger-color);\n}\n\n.badge-info {\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--primary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
